module.exports = __webpack_public_path__ + "static/media/Brand.d6d042aa.jpg";